import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import domToImage from 'dom-to-image';
import jsPDF from 'jspdf';
import styles from './QRcodePage.module.css';
import { nestArrays } from 'store/utility';
import { Button, message, Popconfirm, Modal, Input } from 'antd';
import Spinner from 'components/UI/Spinner/Spinner';
import { clearQRcode, deleteQRcode, updateQRcode, updateProduct } from 'store/actions/index';
import QRLabel from 'components/QRcode/QRLabel';
import * as Page from 'HOC/Layout/PageContainer';

const { Container, Title } = Page;
const { Search } = Input;

class QRcodePage extends Component {
  state = {
    visible: false,
    searchString: '',
  };

  callMe = () => {
    let { items } = this.props;

    if (this.state.searchString !== '') {
      let key = 'title';
      items = items.filter(item => {
        return (
          typeof item[key] !== 'undefined' &&
          item[key].toLowerCase().indexOf(this.state.searchString.toLowerCase()) !== -1
        );
      });
    }

    // const products = convertIDsToObjects(items)
    // generate _2DArray to create multiple canvas for multipage PDF generation
    const _2DArray = nestArrays(items, 8);
    // componentIDs for download event referencing
    const componentIDs = _2DArray.map((_, i) => `HTML_PDF_${i}`);

    return { items, _2DArray, componentIDs };
  };

  renderNoSelection = () => (
    <Container type="2x3">
      <Title title="QR Code" />
      <div className={styles.Main}>
        <div>
          No QR code items, head over to{' '}
          <a
            onClick={() => {
              this.props.history.push('/products');
              message.info("Choose products then click 'Preview Cart' to add to QR codes");
            }}
          >
            products
          </a>{' '}
          to get assign.
        </div>
      </div>
    </Container>
  );

  handleMargins = doc => {
    const collection = doc.getElementsByClassName(styles.Preview);
    for (let i = 0; i < collection.length; i++) {
      collection[i].style.width = '800px';
      collection[i].style.justifyContent = 'left';
      const children = collection[i].childNodes;
      for (let j = 0; j < children.length; j++) {
        if (children[j].nodeName.toLowerCase() === 'div') {
          children[j].style.margin = '0';
        }
      }
    }
    return 'hi';
  };

  // downloadPDFHeavy makes use of an array of IDs pass down by props
  // loops through the array of IDs
  // programmatically addPage and addImage based on the index of that array
  // save whole if its the last page
  downloadPDFHeavy = () => {
    const { componentIDs } = this.callMe();
    const documentScale = 1;
    const docMarginTop = 0;
    const docMarginLeft = 0;
    const doc = new jsPDF('p', 'mm', 'a4');
    const that = this;

    let nodes = [];

    for (let i = 0; i < componentIDs.length; i++) {
      nodes.push(document.getElementById(componentIDs[i]));
      const element = document.getElementById(componentIDs[i]);

      var divs = element.getElementsByTagName('div');
      for (let j = 0; j < divs.length; j++) {
        var buttons = divs[j].getElementsByTagName('button');
        for (let z = 0; z < buttons.length; z++) {
          buttons[z].style.opacity = '0';
        }
      }
    }

    setTimeout(() => {
      Promise.all(nodes.map(node => domToImage.toPng(node))).then(dataArray => {
        for (let j = 0; j < dataArray.length; j++) {
          const originalDataURI = dataArray[j];
          const image = new Image();
          let marginLeft = 175;

          // const resWidth = window.innerWidth;
          // if (resWidth >= 1920) {
          //   marginLeft = 350;
          // }

          image.onload = function() {
            const newDataURI = (function(_, width, height) {
              let canvas = document.createElement('canvas');
              let ctx = canvas.getContext('2d');
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(image, marginLeft, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
              return canvas.toDataURL('image/png');
            })(this, this.width / documentScale, this.height / documentScale);

            if (j > 0) {
              doc.addPage();
            }
            doc.addImage(newDataURI, 'png', docMarginLeft, docMarginTop);

            if (j === componentIDs.length - 1) {
              const dateTime = Date.now();
              const timestamp = Math.floor(dateTime / 1000);
              doc.save('qr_code_' + String(timestamp) + '.pdf');
              message.success('PDF generated');
              // set 500ms timeout for closing modal
              setTimeout(() => {
                that.setState(prev => ({ ...prev, visible: false }));
                const { componentIDs } = that.callMe();
                for (let i = 0; i < componentIDs.length; i++) {
                  const element = document.getElementById(componentIDs[i]);

                  var divs = element.getElementsByTagName('div');
                  for (let j = 0; j < divs.length; j++) {
                    var buttons = divs[j].getElementsByTagName('button');
                    for (let z = 0; z < buttons.length; z++) {
                      buttons[z].style.opacity = '1';
                    }
                  }
                }
              }, 500);
            }
          };
          image.src = originalDataURI;
        }
      });
    }, 500);
  };

  downloadPDFHandler = () => {
    this.setState(prev => ({ ...prev, visible: true }));
    this.downloadPDFHeavy();
    // TODO: make downloadPDFHeavy into a web worker..
    // https://github.com/facebook/create-react-app/issues/1277
    // https://stackoverflow.com/questions/47475360/creating-a-web-worker-inside-react
    // webworkers need to be string blobs tho..
    // MDN: https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers
  };

  clearQRcodeHandler = () => {
    this.props.clearQRcode();
    message.success('All QR codes cleared');
  };

  generateQRcodes = data => {
    const { deleteQRcode, isLoading } = this.props;
    return data.map(product => (
      <QRLabel
        editModalHandler={this.editModalHandler}
        updateProduct={this.props.updateProduct}
        updateQRcode={this.props.updateQRcode}
        deleteQRcode={deleteQRcode}
        key={product.id}
        data={product}
        isLoading={isLoading}
      />
    ));
  };

  onSearchHandler = e => {
    this.setState({
      searchString: e.target.value,
    });
  };

  renderQRLabels = (data, length) => {
    return (
      <Fragment>
        <Modal
          title="PDF Generating"
          wrapClassName={styles.Modal}
          visible={this.state.visible}
          width={350}
          footer={null}
        >
          <Spinner type="Default" size="large" />
        </Modal>
        <Container type="2x3">
          <Title
            title="QR Code"
            className={
              // setting blur for background
              this.state.visible ? styles.Blur : ''
            }
          />
          <div
            className={
              this.state.visible
                ? // setting blur for background
                  styles.Main + ' ' + styles.Blur
                : styles.Main
            }
          >
            <div className={styles.Commands}>
              <Search
                id="qrcode-search-form"
                defaultValue={this.state.searchString}
                placeholder="Input title"
                size="large"
                style={{ width: 400, marginRight: '10px' }}
                onPressEnter={this.onSearchHandler}
              />
              <Button type="primary" size="large" style={{ marginRight: '10px' }} onClick={this.downloadPDFHandler}>
                Download PDF
              </Button>
              <Popconfirm
                key="clear"
                title="Are you sure?"
                okText="Clear all QR codes"
                cancelText="No"
                onConfirm={this.clearQRcodeHandler}
              >
                <Button type="danger" size="large">
                  Clear All
                </Button>
              </Popconfirm>
              <span style={{ float: 'right', lineHeight: '40px' }}>
                <strong>Total Items: {length}</strong>
              </span>
            </div>
            {data.map((e, i) => {
              return (
                <div key={i} id={`HTML_PDF_${i}`} className={styles.Preview}>
                  {this.generateQRcodes(e)}
                </div>
              );
            })}
          </div>
        </Container>
      </Fragment>
    );
  };

  render() {
    // const { items, _2DArray } = this.props
    const { items, _2DArray } = this.callMe();
    // console.log("there 2da", _2DArray);
    // console.log("items",items);

    if (items.length === 0) return this.renderNoSelection();
    else return this.renderQRLabels(_2DArray, items.length);
  }
}

const mapStateToProps = state => {
  const { items } = state.QRcode;
  const isLoading = state.product.loading;

  return {
    items,
    isLoading,
  };
};

const mapDispatchToProps = {
  clearQRcode,
  deleteQRcode,
  updateQRcode,
  updateProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(QRcodePage);



// WEBPACK FOOTER //
// ./src/containers/QRcode/QRcodePage.js